import { useEffect } from "react";
import { NavLink } from "react-router-dom";

export default function Halsingetrailen() {

  useEffect(() => {

    document.getElementById("main")?.scrollIntoView(  { behavior: 'smooth' })
  }, []);

  return (
    <>
      <article id="mainContent">

        <h1>Hälsingetrailen</h1>
        <figure>
          <img src="/images/halsingetrailen_cover.jpg" alt="Hälsingetrailen innan start" />
          <figcaption>Hälsingetrailen innan start</figcaption>
        </figure>


        <h2>Nästa upplaga</h2>
        <p>Datum för nästa upplaga är ännu inte fastställt. Följ Hälsinglands Multisport på Facebook eller Instagram för kommande information.</p>
        <nav>
          <a href="https://www.facebook.com/HalsinglandsMultisport/" target="_blank"><span className="fab fa-facebook"></span> Hälsinglands Multisport</a>
          <a href="https://www.instagram.com/halsinglandsmultisport/" target="_blank"><span className="fab fa-instagram"></span> Hälsinglands Multisport</a>
        </nav>
        <h4>Om loppet</h4>
        <p>
          Hälsingetrailen är ett motionsterränglopp i hjärtat av Hälsinglands skogar som arrangeras av Hälsinglands Multisport. I Segersta får du en riktig utmaning i allt från obanad terräng till skogsstigar och grusväg. Vägvalen är föredömligt snitslade. De längre sträckorna är riktigt kuperade och ger även den erfarne terränglöparen en riktig match.
          Sprintbanan gör att alla kan vara med och springa!
        </p>
        <p>
          Sträckorna som finns att välja på är 18,5, 13 och 6 km
        </p>

        <h4>18,5 km</h4>
        <p>
          Banan för dig som vill ha en tuff utmaning i djupet av Hälsingeskogarna. Underlaget varierar från grus till obanat.
          Vi lämnar garanti på trötta ben!
        </p>

        <h4>13 km</h4>
        <p>
          Mellanbanan är en riktig utmaning i sann Hälsingeterräng där det beryktade Fläckberg ska bestigas.
        </p>

        <h4>6,6 km</h4>
        <p>
          Vår "sprintbana" är en lagom utmaning för alla motionärer som gillar att känna skogen under sina fötter.
        </p>

        <h2>Plats</h2>
        <p>
          Loppet har både start och målgång vid Segersta OKs klubbstuga vid Björktjärn, Segersta. 
        </p>

        <h2>Anmälan</h2>
        <p>Information om anmälan, starttid och avgift för nästa upplaga publiceras när datumet är fastställt.</p>

        <h2>Historiska resultat</h2>
        <p>
          Alla resultat hittar du <NavLink reloadDocument to="/halsingetrailen/resultat">här</NavLink>!
        </p>

        <figure>
          <img src="/images/halsingetrailen_logo.png" alt="Hälsingetrailens jubileumslogotyp" />
          <figcaption>Hälsingetrailen 10-års jubileum</figcaption>
        </figure>
      </article>
    </>
  )
}